module.exports = __webpack_public_path__ + "static/img/sprite-vlieg-right.cab171f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/sprite-vlieg-right.png
// module id = 686
// module chunks = 64